demoSongs from ../data/demo-songs.civet

{ Jadelet, Modal } from @danielx/dui

Template := Jadelet.exec """
section.song-picker
  h2 🎵 Demo Songs
  button.close(click=@close) X
  table
    thead
      tr
        th Title
        th Author
    tbody
      @items
"""

RowTemplate := Jadelet.exec """
tr(@click)
  td @title
  td @author
"""

export DemoPicker := (player) ->
  player.showDemoSongPicker ?= ->
    Modal.show self.element

  self :=
    close: -> Modal.hide()
    items: ->
      demoSongs.map ({title, author, slug}) ->
        RowTemplate
          title: title
          author: author
          click: ->
            Modal.hide()

            player.loadFromSlug(slug)

    element: null

  self.element = Template self

  return self

export default DemoPicker
